











































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Headerhome from '../../components/headerhome.vue';

@Component({
  components: { Headerhome },
})
export default class HelpPage extends Vue {


}
